import React from 'react';
import { CardFace, CardBack } from '../assets/CardAssets';
import '../styles/Card.css';

const Card = ({ card, onClick, playable, isBack = false, position }) => {
  const handleClick = () => {
    if (playable && onClick && !isBack) {
      onClick(card);
    }
  };
  
  const getCardClass = () => {
    let className = 'card';
    
    if (card && card.color) {
      className += ` card-${card.color.toLowerCase()}`;
    }
    
    if (!playable) {
      className += ' card-disabled';
    }
    
    if (isBack) {
      className += ' card-back';
    }
    
    return className;
  };
  
  return (
    <div 
      className={getCardClass()} 
      onClick={handleClick}
      data-testid={card && !isBack ? `card-${card.color || 'wild'}-${card.value}` : 'card-back'}
    >
      <div className="card-inner">
        {isBack ? (
          <CardBack position={position} />
        ) : (
          <CardFace card={card} position={position} />
        )}
      </div>
    </div>
  );
};

export default Card;
